module.exports = __webpack_public_path__ + "assets/img/home-yjzx-light.f767b193.png";